<template>
  <div>
    <ReAssignPOSModal
      :isLinked="tabLinked"
      :modalData="modalData"
      :company="company"
    />
    <MasterLayout>
      <div
        class="fuelbalance_first_row row mx-auto"
        style="justify-content: center; width: 96%"
      >
        <section
          class="fuelbalance_first_row_right_section asset_card col-md-7 py-5 col-sm-12"
        >
          <div class="">
            <div class="our__branches__banner">
              <div
                class="row align-items-center d-flex justify-content-center section__row"
              >
                <div class="col-md-8">
                  <div class="ml_5">
                    <h5 class="primary-color">
                      {{ $t("text.cBank.hi") }}, {{ userName }}
                    </h5>
                    <div class="mt-3">
                      <span class="primary-color">{{
                        $t("text.cBank.terminal2.title")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 text_right">
                  <button class="btn details_btn mb-2" @click="createTerminal">
                    {{ $t("text.bTerminal.createTerminal") }}
                  </button>

                  <button class="btn details_btn mt-2" @click="uploadBulkPOS">
                    {{ $t("text.bTerminal.uploadBulkPOS") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="col-md-5 col-sm-12">
          <div class="card_container grid-col-6">
            <div class="row align-items-center fuel_consumption_buttons_row">
              <div class="mt-3 col-md-6 col-sm-12 fuel_consumption_btn_div">
                <div
                  class="fuel_consumption_button active_tab"
                  style="height: 80px; width: 80px"
                >
                  <h3 class="text-white">{{ linkedTerminalNumber }}</h3>
                </div>
                <div class="mt-3 text-center bold-text primary-color">
                  {{ $t("text.retainership.linkedTerminals") }}
                </div>
              </div>

              <div class="mt-3 col-md-6 col-sm-12 fuel_consumption_btn_div">
                <div
                  class="fuel_consumption_button active_tab"
                  style="height: 80px; width: 80px"
                >
                  <h3 class="text-white">{{ nonLinkedTerminalNumber }}</h3>
                </div>
                <div class="mt-3 text-center bold-text primary-color">
                  {{ $t("text.retainership.nonLinkedTerminals") }}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section>
        <div class="d-flex ml-4 py-2 mt-3 tabs">
          <div
            @click="() => (this.tabLinked = true)"
            class="mr-4 tab"
            :class="tabLinked && 'activeTab'"
          >
            {{ $t("text.retainership.linkedTerminals") }}
          </div>

          <div
            @click="() => (this.tabLinked = false)"
            class="tab"
            :class="!tabLinked && 'activeTab'"
          >
            {{ $t("text.retainership.nonLinkedTerminals") }}
          </div>
        </div>
      </section>
      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div
            class="mt-3 col-md-12 col-lg-12"
            v-show="!terminalLoader && !showLoader"
          >
            <ejs-grid
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :allowTextWrap="true"
              :locale="usedLang"
              :dataSource="tabLinked ? linkedTerminals : nonLinkedTerminals"
            >
              <e-columns>
                <e-column width="80" field="index" headerText="#"></e-column>
                <e-column
                  width="200"
                  field="branchName"
                  :headerText="$t('text.cBank.station')"
                ></e-column>
                <e-column
                  width="200"
                  field="terminalId"
                  :headerText="$t('text.cBank.terminal2.id')"
                ></e-column>

                <e-column
                  width="200"
                  field="vendor"
                  :headerText="$t('text.cBank.terminal2.vendor')"
                ></e-column>

                <e-column
                  width="200"
                  field="balance"
                  :headerText="$t('text.cBank.transaction.balance')"
                ></e-column>
                <e-column
                  :template="terminalTemplate"
                  :headerText="$t('text.cBank.action')"
                  width="380"
                ></e-column>
              </e-columns>
            </ejs-grid>
          </div>
          <div class="mt-3 col-md-12 col-lg-12">
            <TableLoader :showLoader="terminalLoader || showLoader" />
          </div>
        </div>
      </section>
      <!-- <section
        class="pb-5 mt-3 products_summary__wrapper"
        v-show="!terminalCount && !showLoader"
      >
        <div
          class="empty_tank_wrapper"
          style="
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column wrap;
          "
        >
          <div class="text-center" style="margin-top: 30px">
            <h6 style="color: rgb(161, 146, 146); font-size: 13px">
              {{ $t("text.cBank.terminal2.noTerminal") }}
            </h6>
          </div>

          <div class="pb-5 text-center" style="margin-top: 50px">
            <img src="@/assets/img/gold-ingots.svg" width="170" />
          </div>
        </div>
      </section> -->
    </MasterLayout>
    <CreateTerminal
      :branches="branches"
      :modalData="modalData"
      :companyId="company ? company.id : ''"
    />
    <POSBulkUpload
      :branches="branches"
      :modalData="modalData"
      :companyId="company ? company.id : ''"
    />
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import ReAssignPOSModal from "@/components/modals/POS/reAssignPOS.vue";
import CreateTerminal from "@/components/modals/POS/createTerminal.vue";
import POSBulkUpload from "@/components/modals/POS/POSBulkUpload.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import GetAsset from "@/components/modals/Assets/getAsset.vue";
import Paginator from "@/components/Paginator.vue";
import Temp from "@/components/terminalsTemplate.vue";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "POS Terminals :: Epump Portal",
  name: "Assets",
  components: {
    MasterLayout,
    // AssetDetails,
    GetAsset,
    Paginator,
    TableLoader,
    ReAssignPOSModal,
    CreateTerminal,
    POSBulkUpload,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      terminalLoader: false,
      usedLang: this.$store.getters.getLanguage,
      linkedTerminalNumber: 0,
      nonLinkedTerminalNumber: 0,
      tabLinked: true,
      linkedTerminals: [],
      nonLinkedTerminals: [],
      asset: {},
      addAssetId: "",
      fromDate: null,
      toDate: null,
      branches: [],
      branchId: "allBranches",
      status: "allStatus",
      isActive: "selectActive",
      assetData: {},
      tableCount: 0,
      first: true,
      pageSize: "10",
      totalPages: 1,
      currentPage: 1,
      sortType: "",
      sortColumn: "",
      assetNumber: "",
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      company: null,
      backgroundUrl,
      cardBackgroundUrl,
      groupAssets: [],
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      terminalCount: 0,
      modalData: {},
      terminalTemplate: function () {
        return {
          template: Temp,
        };
      },
    };
  },
  computed: {
    userName() {
      return `${this.userDetails.firstName} ${this.userDetails.lastName}`;
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      this.getBranches();
    });
    if (this.$route.query.companyId) {
      this.getBranches();
    }
    this.$eventHub.$on("_reAssignPOSModal", (data) => {
      this.modalData = data;
      this.$modal.show("reAssignPOS");
    });
    this.$eventHub.$on("_createTerminal", (data) => {
      this.modalData = data;
      this.$modal.show("createTerminal");
    });
    this.$eventHub.$on("_uploadBulkPOS", (data) => {
      this.modalData = data;
      this.$modal.show("uploadBulkPOS");
    });

    this.$eventHub.$on("refreshTerminalsList", () => {
      this.getBranches();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("setAssetModalValue");
    this.$eventHub.$off("refreshTerminalsList");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    // this.getBranches();
  },
  watch: {},

  methods: {
    //Modal
    createTerminal() {
      this.$modal.show("createTerminal");
    },
    uploadBulkPOS() {
      this.$modal.show("uploadBulkPOS");
    },

    //Utilities
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    //Requests
    getBranches() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig(),
        )
        .then((response) => {
          this.showLoader = false;
          response.data.forEach((data) => {
            data.value = data.id;
            data.text = data.name;
          });
          this.branches = response.data;
          this.getTerminals();
          this.getNotLinkedTerminals();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    getNotLinkedTerminals() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pos/Terminals?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig(),
        )
        .then((res) => {
          res.data = res.data.filter((el) => !el.linked);

          let index = 0;
          res.data.sort((a, b) => {
            return a.balance > b.balance ? 1 : b.balance > a.balance ? -1 : 0;
          });

          res.data.forEach((el) => {
            el.index = ++index;
            let branchName = this.branches.filter((branch) => {
              return el.branchId === branch.id;
            });
            if (branchName.length > 0 && branchName[0].name) {
              el.branchName = branchName[0].name;
            } else {
              el.branchName = "---";
            }
            el.vendor = el.vendor ? el.vendor : "N/A";

            el.fee = this.convertThousand(el.fee);
            el.balance = this.convertThousand(el.balance);
          });

          this.terminalCount = res.data.length;

          this.nonLinkedTerminals = res.data.filter((el) => !el.linked);

          this.nonLinkedTerminalNumber = this.nonLinkedTerminals.length;
          this.refreshGrid();
        })
        .catch((error) => {});
    },

    getTerminals() {
      this.terminalLoader = true;
      this.axios
        .get(
          `${configObject.posBaseUrl}/Pos/company/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.remisConfig(),
        )
        .then((res) => {
          res.data = res.data.filter((el) => el.linked);
          let index = 0;
          res.data.sort((a, b) => {
            return a.balance > b.balance ? 1 : b.balance > a.balance ? -1 : 0;
          });
          res.data.forEach((el) => {
            el.index = ++index;
            let branchName = this.branches.filter((branch) => {
              return el.branchId === branch.id;
            });
            if (branchName.length > 0 && branchName[0].name) {
              el.branchName = branchName[0].name;
            } else {
              el.branchName = "---";
            }

            el.vendor = el.vendor ? el.vendor : "N/A";

            el.fee = this.convertThousand(el.fee);
            el.balance = this.convertThousand(el.balance);
          });

          this.terminalCount = res.data.length;
          this.linkedTerminals = res.data;

          this.linkedTerminalNumber = this.linkedTerminals.length;

          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        })
        .finally(() => {
          this.terminalLoader = false;
        });
    },
  },
};
</script>

<style scoped>
.tab {
  color: #4c2e73;
  padding: 0px 6px;
  font-weight: 500;
  cursor: pointer;
}

.activeTab {
  padding-bottom: 6px;
  border-bottom: 3px solid;
}
</style>
